import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import PageHeader from './PageHeader';
import { Link } from 'react-router-dom';

const HelpPage = () => {
    const { getFullTranslation } = useLanguage();
    const t = getFullTranslation('helpPage');

    const categories = [
        { to: '/#faq', title: t.category1, desc: t.category1desc, icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /> },
        { to: '/subscription', title: t.category2, desc: t.category2desc, icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /> },
        { to: '/features', title: t.category3, desc: t.category3desc, icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /> },
        { to: '/changelog', title: t.category4, desc: t.category4desc, icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /> },
    ];

    const faqs = [
        { q: t.q1, a: t.a1 },
        { q: t.q2, a: t.a2 },
        { q: t.q3, a: t.a3 },
        { q: t.q4, a: t.a4 },
        { q: t.q5, a: t.a5 },
    ];

    return (
        <div>
            <PageHeader title={t.title} subtitle={t.subtitle} />

            <div className="max-w-4xl mx-auto px-6 py-16">
                {/* Category Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                    {categories.map((cat, i) => (
                        <Link key={i} to={cat.to} className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-orange-500 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-orange-100 transition-all block">
                            <div className="w-14 h-14 bg-orange-50 rounded-xl flex items-center justify-center mb-4">
                                <svg className="w-7 h-7 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">{cat.icon}</svg>
                            </div>
                            <h3 className="text-lg font-bold text-gray-900 mb-2">{cat.title}</h3>
                            <p className="text-gray-500 text-sm">{cat.desc}</p>
                        </Link>
                    ))}
                </div>

                {/* FAQ */}
                <div className="mt-12">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">{t.faqTitle}</h2>
                    <div className="space-y-4">
                        {faqs.map((faq, i) => (
                            <div key={i} className="bg-white rounded-xl p-6 border border-gray-200">
                                <div className="font-semibold text-gray-900 mb-2">{faq.q}</div>
                                <div className="text-gray-500 text-sm">{faq.a}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Contact CTA */}
                <div className="bg-gradient-to-br from-[#163020] to-[#0f1f15] rounded-3xl p-12 text-center text-white mt-12">
                    <h2 className="text-2xl font-bold mb-3">{t.noAnswer}</h2>
                    <p className="opacity-80 text-sm mb-6">{t.contactSubtitle}</p>
                    <div className="flex justify-center gap-4 flex-wrap">
                        <a href="mailto:andy.caoyueyang@gmail.com" className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition">{t.sendEmail}</a>
                        <a href="https://xhslink.com/m/9qO0DwhnJwR" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border-2 border-white/30 text-white font-semibold rounded-xl hover:bg-white/10 transition">{t.xiaohongshu}</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpPage;
